import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from "styled-components";
import { createStyleComponent, getThemeData } from "@hzero-front-ui/core";
function MentionsStyle(props) {
  var _getThemeData = getThemeData(props, "common"),
    primary = _getThemeData.primary;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .c7n-pro-mentions-wrapper {\n      label:hover .c7n-pro-mentions,\n      .c7n-pro-mentions:hover {\n        border-color: ", ";\n      }\n    }\n  "])), primary);
}
export default createStyleComponent("mentions", MentionsStyle);